import { PnIntroComponent } from 'src/app/client/patientnavigator/components/pn-intro-component/pn-intro-component.component';
import {
  HOME_DEFAULT_TAB,
  PnHomePageTabsComponent,
} from 'src/app/client/patientnavigator/components/pn-home-page-tabs/pn-home-page-tabs.component';
import { MainMenuComponent } from 'src/app/components/main-menu/main-menu.component';
import {
  createDefaultEnvironmentLayout,
  EnvironmentLayout,
} from 'src/environments/environment-layout.base';

export const homeHealthScoreRedirectTo = 'pn-dashboard';

export const environmentLayout: EnvironmentLayout = {
  ...createDefaultEnvironmentLayout(),
  introComponent: PnIntroComponent,
  homePageTabsComponent: PnHomePageTabsComponent,
  homeHealthScoreRedirectTo,
};

export const mainMenuComponent = MainMenuComponent;
export const homePageTabsComponent = PnHomePageTabsComponent;
export const introComponent = PnIntroComponent;
export const homeDefaultTab = HOME_DEFAULT_TAB;
